import React from 'react';
import { bool, shape, string } from 'prop-types';

const Harrowing = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 16V20H19V18H17V20H15V18H13V20H11V18H9V20H7V18H5V20H3V16H21Z" fill="currentColor" />
    <path d="M21 14H19V12H17V14H15V12H13V14H11V12H9V14H7V12H5V14H3V10H21V14Z" fill="currentColor" />
    <path d="M21 8H19V6H17V8H15V6H13V8H11V6H9V8H7V6H5V8H3V4H21V8Z" fill="currentColor" />
  </svg>
);

Harrowing.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Harrowing;
